import { Form } from "antd";

const FormMc = () => {
  const [form] = Form.useForm();

  return <Form form={form} id="formMc" layout="vertical"></Form>;
};

export default FormMc;
